import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { signoutUser } from '../actions/auths';
import { useIdleTimer } from './useIdleTimer';

const ACTION_THROTTLE = 3000;
const authTokenName = 'token';
const lastTimestampName = 'last_action_at';

const TWO_HOURS = 7200000;
const EIGHT_HOURS = 28800000;

const IdleManager = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const getIdleTimeout = () => {
    if (isAdmin()) {
      return EIGHT_HOURS;
    }
    return TWO_HOURS;
  };

  const isInClientSession = () =>
    location.pathname.startsWith('/sessions/clients');

  const isAdmin = () => location.pathname.startsWith('/admin');

  const handleIdle = () => {
    const token = localStorage.getItem(authTokenName);
    const lastTimestamp = localStorage.getItem(lastTimestampName);
    const nowTimestamp = Date.now();

    if (token) {
      if (
        lastTimestamp &&
        nowTimestamp - lastTimestamp > getIdleTimeout()
      ) {
        signOut();
      }
    } else {
      history.push('/signin');
    }
  };

  const handleActive = () => {
    const token = localStorage.getItem(authTokenName);

    if (!token) {
      history.push('/signin');
    }
  };

  const saveTimestamp = () => {
    const token = localStorage.getItem(authTokenName);

    if (token) {
      localStorage.setItem(lastTimestampName, Date.now());
    }
  };

  const signOut = () => {
    dispatch(signoutUser());
    history.push('/signin');
  };

  useEffect(() => {
    const token = localStorage.getItem(authTokenName);
    const lastTimestamp = localStorage.getItem(lastTimestampName);

    if (token && !isInClientSession()) {
      if (lastTimestamp && Date.now() - lastTimestamp > getIdleTimeout()) {
        signOut();
      } else {
        saveTimestamp();
      }
    }
  }, []);

  useIdleTimer({
    onIdle: handleIdle,
    onAction: saveTimestamp,
    onActive: handleActive,
    throttle: ACTION_THROTTLE,
    timeout: getIdleTimeout(),
    enabled: !isInClientSession(),
  });

  return null;
};

export default IdleManager;
